"use client";

import { useEffect } from "react";
import {
  captureAttributionFromUrl,
  captureFbcFromUrl,
  captureLandingAngle,
  getOrCreateExternalId,
  readAttribution,
} from "@/lib/attribution";
import { initPixelIdentity } from "@/lib/fbq";
import { registerAttributionForPostHog } from "@/lib/posthog";

export function AttributionCapture() {
  useEffect(() => {
    captureAttributionFromUrl(window.location.search);
    // An SEO page names the angle it stands for; a visitor who lands on it with no angle yet keeps it.
    captureLandingAngle(document.querySelector<HTMLElement>("[data-landing-angle]")?.dataset.landingAngle);
    captureFbcFromUrl(window.location.search);
    // Mint/persist the stable external_id and attach it to the Pixel so every
    // client event (and the deduplicated server events) match on it — lifts
    // event-match quality and dedup coverage even without an fbc.
    getOrCreateExternalId();
    initPixelIdentity();
    // Mirror the persisted attribution into PostHog as super-properties so every
    // subsequent event carries acquisition_angle/utm_* — required for funnel-by-angle.
    registerAttributionForPostHog(readAttribution());
  }, []);
  return null;
}
